import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { normalizeDecimal,
  renderAutoCompleteSingleSelect,
  renderTextField,
  renderCheckBox,
  renderDateField,
} from './../../../../components/reduxFields';
import { getMasterData, getStaffPayRatesforActivities, getStaffsAndPatientsByLocation, saveStaffPayRatesforActivities, getAppointmentTypeList } from '../../actions/UserActions';
import Alert from 'react-s-alert';
import { Field, FieldArray, formValueSelector, reduxForm, change } from 'redux-form';
import { CommonButton } from '../../../../components/buttons';
import moment from 'moment';
import _ from 'lodash';
import { ADASTRA, VIP } from '../../../../actions/utilAction';

const validate = (values) => {
  const errors = {};
  if (values.Payroll && values.Payroll.length) {
    const payrollArrayErrors = [];
    values.Payroll.forEach((Obj, index) => {
      const payrollErrors = {};
      if (Obj !== undefined && !Obj.appointmentTypeId) {
        payrollErrors.appointmentTypeId = 'Please select appointment type';
      }
      if (Obj !== undefined && (!Obj.payRate || parseFloat(Obj.payRate || 0) === 0)) {
        payrollErrors.payRate = 'Please enter pay rate';
      }
      payrollArrayErrors[index] = payrollErrors;
    });
    if (payrollArrayErrors.length) {
      errors.Payroll = payrollArrayErrors;
    }
  }

  return errors;
};


class UserPayrollList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      staffId: null,
      clickedAppointmentTypes: [],
      startDate: [],
      endDate: [],           
      lastIndexOfEndDate: null, 
      ShowStaffOfAllLocations: false,
      ShowInactiveUsersOnly: false,
    };
    this.setSortColumn = this.setSortColumn.bind(this);
    this.handleNewRequestForStaff = this.handleNewRequestForStaff.bind(this);
    this.handleNewRequest = this.handleNewRequest.bind(this);
    this.addRow = this.addRow.bind(this);
    this.removeRow = this.removeRow.bind(this);
    this.updatePayrollRates = this.updatePayrollRates.bind(this);
    this.changePayrate = this.changePayrate.bind(this);
    this.renderData = this.renderData.bind(this);
    this.handleCheckIsPrimaryActivity = this.handleCheckIsPrimaryActivity.bind(this);
  }

  loadData() {
    if (this.state.staffId)
      this.props.getStaffPayRatesforActivities(this.state.staffId);
  }

  componentWillMount() {
    let masterData = 'masterAllStaff';
    this.props.getMasterData(masterData);
    this.loadStaffDropdown();
    this.props.getAppointmentTypeList();
  }

  loadStaffDropdown()
  {
    let searchObj = {
      locationIds: this.state.ShowStaffOfAllLocations ? '0' : this.props.currentLocationId ? this.props.currentLocationId : '0',
      permissionKey: 'SCHEDULING_LIST_VIEW_OTHERSTAFF_SCHEDULES',
      isActiveCheckRequired: this.state.ShowInactiveUsersOnly ?  'NO' : 'YES', 
    };
    this.props.getStaffsAndPatientsByLocation(searchObj);    
    this.loadData();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.saved_staffPayrollRates && nextProps.saved_staffPayrollRates !== this.props.saved_staffPayrollRates) {
      this.loadData();
    }

    if (nextProps.staffPayrollRates && nextProps.staffPayrollRates.data && nextProps.staffPayrollRates != this.props.staffPayrollRates) {      
      let startDate = this.state.startDate;
      let endDate = this.state.endDate;
      (nextProps.staffPayrollRates.data || []).forEach((obj, index) => {
          
          if(obj.startDate != undefined)
          {
            _.update(startDate, `[${index}]`, function (n) {
                return moment(obj.startDate).format('MM-DD-YYYY');
            });
          
            this.props.dispatch(change('UserPayrollListForm', `Payroll[${index}].startDate`, moment(obj.startDate).format('MM-DD-YYYY') || null));
          }
          // else
          // {
          //   _.update(startDate, `[${index}]`, function (n) {
          //     return new Date();
          //   });
          // }

          if(obj.endDate != undefined)
          {
            _.update(endDate, `[${index}]`, function (n) {
                return moment(obj.endDate).format('MM-DD-YYYY');
            });

            this.props.dispatch(change('UserPayrollListForm', `Payroll[${index}].endDate`, moment(obj.endDate).format('MM-DD-YYYY') || null));
          }
          
      });

      this.setState({ startDate: startDate, endDate: endDate });
   
    }
  }
  handleNewRequest = (input, selectedRecord, i) => {

    input.onChange(selectedRecord.value);

    let selectorPayroll = this.props.selectorPayroll || [];
    let selectedDateIndex  = this.state.startDate.length - 1;
    
    let endDate = this.state.endDate;
    let lastIndexOfEndDate = this.state.lastIndexOfEndDate;
    let endDateOfLastSameActivity  = moment(this.state.startDate[selectedDateIndex]).subtract(1, "days").format('MM-DD-YYYY');
    
    selectorPayroll.forEach((obj, index) => {
      if(obj.appointmentTypeId === selectedRecord.value && (endDate[index] === undefined || endDate[index] === null) && i !== index)
      {
        lastIndexOfEndDate = index;
        endDate[index] = this.state.startDate[index] > endDateOfLastSameActivity ? this.state.startDate[index] : endDateOfLastSameActivity;
      }
    });    

    if(lastIndexOfEndDate >= this.props.selectorPayroll.length -1)
    {
      lastIndexOfEndDate = lastIndexOfEndDate - 1;
    }

    this.setState({endDate: endDate, lastIndexOfEndDate: lastIndexOfEndDate},()=>{     
      this.props.dispatch(change('UserPayrollListForm', `Payroll[${lastIndexOfEndDate}].endDate`, moment(endDate[lastIndexOfEndDate]).format('MM-DD-YYYY') || null));
    });
  }

  handleCheckIsPrimaryActivity = (e, checked, payrollIndex) => {
    let selectorPayroll = this.props.selectorPayroll || [];
    selectorPayroll.forEach((obj, index) => {
      if (payrollIndex !== index)
        this.props.dispatch(change('UserPayrollListForm', `Payroll[${index}].isPrimaryActivity`, false))
    })
  }

  componentWillUnmount() {
    Alert.closeAll();
  }

  setSortColumn(sortColumn, sortOrder) {
    if (sortColumn) {
      this.filter.sortColumn = sortColumn;
      this.filter.sortOrder = sortOrder;
      this.loadData();
    }
  }

  handleNewRequestForStaff(input, selectedRecord) {
    input.onChange(selectedRecord.value);
    this.setState({ 
      staffId: selectedRecord.value || null,
      startDate: [],
      endDate: [],      
     }, () => {
      this.loadData();
    });
  }

  changePayrate(payrollApptId) {
    let clickedAppointmentTypes = this.state.clickedAppointmentTypes;
    clickedAppointmentTypes.push(payrollApptId);
    this.setState({ clickedAppointmentTypes });
  }

  updatePayrollRates(formData) {
    formData.Payroll.map((obj,index) => {
      obj.staffId = this.props.selectorStaffId;
      obj.startDate =  obj.startDate ? moment(obj.startDate).isValid() ? (moment(obj.startDate).format('YYYY-MM-DD') + 'T' + moment(obj.startDate).format('HH:mm:ss')) : null : this.state.startDate[index];
      obj.endDate =  obj.endDate ? moment(obj.endDate).isValid() ? (moment(obj.endDate).format('YYYY-MM-DD') + 'T' + moment(obj.endDate).format('HH:mm:ss')) : null : (this.state.endDate[index] || null);
      return obj;
    });

    let postData = formData.Payroll;
    // console.log('formData..', JSON.stringify(postData));
    this.props.saveStaffPayRatesforActivities(postData);
  }

  onDateChange = (input, value, i, type) => {
    input.onChange(moment(value).format());
    if(type === 'FROM DATE')
    {
        let startDate = this.state.startDate;

        _.update(startDate, `[${i}]`, function (n) {
          return moment(value).format('YYYY-MM-DD') + 'T' + moment(value).format('HH:mm:ss');
        });

        this.setState({ startDate: startDate }, ()=>{                  
          document.getElementsByName(`Payroll[${i}].endDate`)[0].focus();  
      });

      let selectorPayroll = this.props.selectorPayroll || [];
      let selectedDateIndex  = this.state.startDate.length - 1;      
      let endDate = this.state.endDate;              
      let endDateOfLastSameActivity  = moment(this.state.startDate[selectedDateIndex]).subtract(1, "days");
      //console.log('this.state.startDate[selectedDateIndex]...........',this.state.startDate[selectedDateIndex])
      
      selectorPayroll.forEach((obj, index) => {        
        if(obj.appointmentTypeId === selectorPayroll[i].appointmentTypeId  && this.state.lastIndexOfEndDate !== null)
        {      
        //  console.log('this.state.startDate[index]...........',this.state.startDate[index])
        //  console.log('endDateOfLastSameActivity...........',endDateOfLastSameActivity)
          endDate[this.state.lastIndexOfEndDate] = this.state.startDate[index] > endDateOfLastSameActivity ? this.state.startDate[index] : endDateOfLastSameActivity;      
        }
      });
      //console.log('endDate[this.state.lastIndexOfEndDate]...........',endDate[this.state.lastIndexOfEndDate])

      this.setState({endDate: endDate},()=>{
        this.props.dispatch(change('UserPayrollListForm', `Payroll[${this.state.lastIndexOfEndDate}].endDate`, moment(endDate[this.state.lastIndexOfEndDate]).format('MM-DD-YYYY') || null));
      });
      
    }
    else if(type === 'TO DATE')
    {
        let endDate = this.state.endDate;

        _.update(endDate, `[${i}]`, function (n) {
          return moment(value).format('YYYY-MM-DD') + 'T' + moment(value).format('HH:mm:ss');
        });

        this.setState({ endDate: endDate }, ()=>{                  
          document.getElementsByName(`Payroll[${i}].startDate`)[0].focus();           
      });
    }
  }

  handleAdvanceFilterCheck = (input, name) => {
    this.setState({ [name]: input.target.checked },
      () => {
        this.loadStaffDropdown();
      });
  }

  addRow = () => {};
  removeRow = (i) => {};
  renderData = ({ fields }) => {
    this.addRow = () => {
      fields.push({});
    };
    this.removeRow = (index) => {
      fields.remove(index);
      this.setState({
        startDate: this.state.startDate.filter((_, i) => i !== index),
        endDate: this.state.endDate.filter((_, i) => i !== index)
      });
    };

    if (!this.props.selectorStaffId) {
      return (
        <tbody>
          <tr>
            <td colSpan="5">
              <div className="familydl text-center no-record">No staff selected</div>
            </td>
          </tr>
        </tbody>
      );
    }
    let startDate = this.state.startDate;
    let endDate = this.state.endDate;
    return (
      <tbody>
        { fields.map((Obj, index) => {

          if(this.state.startDate[index] === undefined)
          {   
            _.update(startDate, `[${index}]`, function (n) {
              //return new Date();
              return moment(new Date()).format('MM-DD-YYYY');
            });          
            this.setState({ startDate: startDate });
          }

          if(this.state.endDate[index] === undefined)
          {   
            _.update(endDate, `[${index}]`, function (n) {
              return null;
            });          
            this.setState({ endDate: endDate });
          }
          //let payrollObj = this.props.selectorPayroll && this.props.selectorPayroll[index];
          //let selectedIndexAppointmentType = payrollObj && payrollObj.appointmentTypeId;
          // let isUpdatePayRate = (clickedAppointmentTypes || []).includes(payrollObj && payrollObj.id);
          // let isUpdateAction = (payrollObj && payrollObj.id) ? false : true;
          // console.log(isUpdateAction, isUpdatePayRate);
          return (
            <tr key={index}>              
              <td>
                <div className='pdt-25'>
                  <Field
                    name={`Payroll[${index}].appointmentTypeId`}
                    hintText='Appointment Type'
                    handleNewRequest={(input, selectedRecord) => this.handleNewRequest(input, selectedRecord, index)}
                    options= {this.props.appointmentTypes}
                    component={renderAutoCompleteSingleSelect}
                  />
                </div>
              </td>
              <td>
                <Field
                  name={`Payroll[${index}].payRate`}
                  hintText='Pay Rate'
                  maxLength={10}
                  normalize={normalizeDecimal}
                  component={renderTextField}
                />
              </td>
              <td>
                <Field
                    name={`Payroll[${index}].startDate`}
                    placeholder="From Date"
                    locale="en-US"
                    selected={this.state.startDate[index] || new Date()}
                    onDateChange={(input, value) => this.onDateChange(input, value, index, 'FROM DATE')}
                    openToYearSelection={true}
                    component={renderDateField} />
            </td>
            <td>
                <Field
                  name={`Payroll[${index}].endDate`}
                  placeholder="To Date"
                  locale="en-US"
                  selected={this.state.endDate[index] || null}
                  onDateChange={(input, value) => this.onDateChange(input, value, index, 'TO DATE')}
                  openToYearSelection={true}
                  component={renderDateField} />
            </td>
              <td>
                <Field
                  name={`Payroll[${index}].isPrimaryActivity`}
                  // label='Is Primary Activity'
                  onChange={(e, checked)=> this.handleCheckIsPrimaryActivity(e, checked, index)}
                  component={renderCheckBox}
                />
              </td>
              <td>
                {fields.length === index + 1 ?
                  <div>
                    {fields.length > 1 ?
                      <button className="tableless"
                        onClick={this.removeRow.bind(this, index)}
                        title="Remove row"
                        type="button">
                        <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                      </button>
                    : ''}
                    <button className="tableadd" type="button" title="Add Appointment Type" onClick={(e) => this.addRow()}>
                      <b className="fa fa-plus-square greenfont" aria-hidden="true"></b>
                    </button>
                  </div>
                  :
                  <div>
                    <button className="tableless"
                      onClick={this.removeRow.bind(this, index)}
                      title="Remove row"
                      type="button">
                      <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                    </button>
                  </div>
                }
              </td>
            </tr>
          );
        })
        }
      </tbody>
    );
  }


  renderOldData = ({ fields }) => {

    this.addRow = () => {
      fields.push({});
    };
    this.removeRow = (index) => {
      fields.remove(index);
    };

    if (!this.props.selectorStaffId) {
      return (
        <tbody>
          <tr>
            <td colSpan="3">
              <div className="familydl text-center no-record">No staff selected</div>
            </td>
          </tr>
        </tbody>
      );
    }
    return (
      <tbody>
        { fields.map((Obj, index) => {
          let restSelectorPayRolls = (this.props.selectorPayroll || []).filter((obj, pIndex) => pIndex !== index),
            dropdownFilteredAppointmentTypes = _.differenceWith(this.props.appointmentTypes, restSelectorPayRolls, function(o1, o2) {
              return (o2['appointmentTypeId'] === o1['id']);
            });

          let payrollObj = this.props.selectorPayroll && this.props.selectorPayroll[index];
          let selectedIndexAppointmentType = payrollObj && payrollObj.appointmentTypeId;
          // let isUpdatePayRate = (clickedAppointmentTypes || []).includes(payrollObj && payrollObj.id);
          // let isUpdateAction = (payrollObj && payrollObj.id) ? false : true;
          // console.log(isUpdateAction, isUpdatePayRate);
          return (
            <tr key={index}>              
              <td>
                <div className='pdt-25'>
                  <Field
                    name={`Payroll[${index}].appointmentTypeId`}
                    hintText='Appointment Type'
                    handleNewRequest={(input, selectedRecord) => this.handleNewRequest(input, selectedRecord)}
                    options= {dropdownFilteredAppointmentTypes}
                    component={renderAutoCompleteSingleSelect}
                  />
                </div>
              </td>
              <td>
                <Field
                  name={`Payroll[${index}].payRate`}
                  hintText='Pay Rate'
                  maxLength={10}
                  normalize={normalizeDecimal}
                  component={renderTextField}
                />
              </td>
              <td>
                <Field
                  name={`Payroll[${index}].isPrimaryActivity`}
                  // label='Is Primary Activity'
                  onChange={(e, checked)=> this.handleCheckIsPrimaryActivity(e, checked, index)}
                  component={renderCheckBox}
                />
              </td>
              <td>
                <div>
                  {(index > 0) && !selectedIndexAppointmentType ?
                    <button className="tableless"
                      onClick={this.removeRow.bind(this, index)}
                      title="Remove row"
                      type="button">
                      <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                    </button> : null}

                  { (fields.length - 1) === index ?
                    <button className="tableadd" type="button" title="Add Appointment Type" onClick={() => this.addRow()}>
                      <b className="fa fa-plus-square greenfont" aria-hidden="true"></b>
                    </button>
                    : null}
                </div>
              </td>
            </tr>
          );
        })
        }
      </tbody>
    );
  }

  render() {
    const { handleSubmit } = this.props;
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.condensed,
      'table-bordered': this.props.bordered,
      'table-hover': true,
      'table-condensed': this.props.condensed,
      'customtable': true,
    });
    return (
      <div className="row">
        <div className="col-sm-12">
          <h2 className="page_title">Manage Payroll Rates</h2>
          <div className="clearfix"></div>
          <div className="readmin-panel">
            <div className="panel-body">
              <form className="readmin-form custom_form" onSubmit={handleSubmit(this.updatePayrollRates)}>
                <div className="modalwindow">
                  <div className="row">
                    <div className="col-sm-4 mt-30">
                      <Field
                        name="StaffId"
                        label="Staff"
                        handleNewRequest={this.handleNewRequestForStaff}
                        options={this.props.staffsList}
                        component={renderAutoCompleteSingleSelect}/>
                    </div>
                    <div className="col-sm-4 field-mr mt-30">
                        <Field
                          name="ShowStaffOfAllLocations"
                          label="Include All Locations"
                          component={renderCheckBox}
                          checked={this.state.ShowStaffOfAllLocations ? true : false}
                          onChange={(e) => this.handleAdvanceFilterCheck(e, 'ShowStaffOfAllLocations')}
                        />
                      </div>
                      <div className="col-sm-4 field-mr mt-30">
                        <Field
                          name="ShowInactiveUsersOnly"
                          label="Show Inactive Staff Only"
                          component={renderCheckBox}
                          checked={this.state.ShowInactiveUsersOnly ? true : false}
                          onChange={(e) => this.handleAdvanceFilterCheck(e, 'ShowInactiveUsersOnly')}
                        />
                      </div>  
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="table-responsive mt-15">
                      <table className={tableClass}>
                      {/* {this.props.agencyName.toUpperCase() === VIP || this.props.agencyName.toUpperCase() === 'DEMO' || this.props.agencyName.toUpperCase() === ADASTRA ? */}
                        <thead>
                          <tr>                            
                            <th width="30%">Appointment Type</th>
                            <th width="10%">Pay Rate</th>
                            <th width="15%">Start Date</th>
                            <th width="15%">End Date</th>
                            <th width="20%">Primary Activity</th>
                            <th width="10%">Action</th>
                          </tr>
                        </thead>
                        {/* :
                        <thead>
                          <tr>                            
                            <th width="30%">Appointment Type</th>
                            <th width="40%">Pay Rate</th>
                            <th width="20%">Primary Activity</th>
                            <th width="10%">Action</th>
                          </tr>
                        </thead>
                        } */}

                        {/* {this.props.agencyName.toUpperCase() === VIP || this.props.agencyName.toUpperCase() === 'DEMO' || this.props.agencyName.toUpperCase() === ADASTRA ? */}
                          <FieldArray name='Payroll' component={this.renderData} />
                          {/* : 
                          <FieldArray name='Payroll' component={this.renderOldData} />
                        } */}

                      </table>
                    </div>
                    {this.props.selectorStaffId && this.props.updatePermission ?
                      <div className="row">
                        <div className="col-sm-12 pt20 btn_rt">
                          <CommonButton type="submit" primary={true} label= "Update Payroll Rate(s)"/>
                        </div>
                      </div>
                      : null }
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


UserPayrollList = reduxForm({
  form: 'UserPayrollListForm',
  enableReinitialize: true,
  validate,
})(UserPayrollList);

const selector = formValueSelector('UserPayrollListForm');

function mapStateToProps(state) {
  let appointmentTypes = [],
    initialValueData = {
      'StaffId': selector(state, 'StaffId'),
      'Payroll': [{}],
    };
  // if (state.user.master_data) {
  //   appointmentTypes = state.user.master_data.appointmentType || [];
  // }

  if (state.user.appointmentTypeList && state.user.appointmentTypeList.data) {
    appointmentTypes = state.user.appointmentTypeList.data.appointmentTypes;
  }
  let staffsByLocation = [];
  if (state.user.staffsAndPatientsByLocation && state.user.staffsAndPatientsByLocation.data) {
    // staffsByLocation = state.user.staffsAndPatientsByLocation.data.staff || [];
    staffsByLocation = state.user.staffsAndPatientsByLocation.data.staff || [];
  }

  // Start For Role Permission
  let userActionPermission = [];
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === "USER");
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === "USER_PAYROLL_LIST" && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }

  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission
  let updatePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === "USER_PAYROLL_LIST_UPDATE_PAYROLL_RATE")[0].permission : false;
  // End For Role Permission

  if (state.user.staffPayrollRates) {
    initialValueData = {
      'StaffId': selector(state, 'StaffId'),
      'Payroll': state.user.staffPayrollRates.data,
    };
  }
  return {
    currentLocationId: state.login.currentLocationId,
    staffsList: staffsByLocation,
    appointmentTypes: appointmentTypes,
    initialValues: initialValueData,
    selectorPayroll: selector(state, 'Payroll'),
    selectorStaffId: selector(state, 'StaffId'),
    saved_staffPayrollRates: state.user.saved_staffPayrollRates,
    updatePermission: updatePermission,
    staffPayrollRates: state.user.staffPayrollRates,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
  };
}


export default connect(mapStateToProps, { getMasterData, getStaffsAndPatientsByLocation, getStaffPayRatesforActivities, saveStaffPayRatesforActivities, getAppointmentTypeList })(UserPayrollList);



// WEBPACK FOOTER //
// ./src/modules/users/component/userPayroll/userPayrollList.js